import Utils from "../../../../../shared/utils"

export const IMAGE_URL = Utils.buildProductPageImageLink("rent/all-in-advance/first-section.svg")

export const MAIN_TITLE_ICON = Utils.buildProductPageImageLink("icons/house-icon.svg")